import React, { useRef, useState } from 'react'
import { Form, Container, Card, Alert } from 'react-bootstrap'
import { useAuth } from '../contexts/AuthContext'
import { Link, useHistory } from 'react-router-dom'
import Image from '../image/img/profile-img.png'
import Header from './Header'
import Footer from './Footer'

export default function UpdateProfile() {

    const emailRef = useRef()
    const passwordRef = useRef()
    const passwordConfirmRef = useRef()
    const { currentUser, updatePassword, updateEmail } = useAuth()
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)
    const history = useHistory()

    function handleSubmit(e){
        e.preventDefault();

        if(passwordRef.current.value !== passwordConfirmRef.current.value){
            return setError('Las contraseñas no coinciden');
        }

        const promises = []
        setLoading(true)
        setError('')

        if(emailRef.current.value !== currentUser.email){
            promises.push(updateEmail(emailRef.current.value))
        }
        if(passwordRef.current.value !== currentUser.password){
            promises.push(updatePassword(passwordRef.current.value))
        }

        Promise.all(promises).then(() => {
            history.push('/')
        }).catch(() =>{
            setError('Debes llenar todos los campos')
        }).finally(() =>{
            setLoading(false)
        })

    }

    return (
    <>
        <div class="site-wraper overflow-hidden position-relative">
        <Header/>
            <Container className="d-flex align-items-center justify-content-center panel">
                <div className="container h-100 my-3">
                    <div className="row d-flex justify-content-center align-items-center h-100">
                        <div className="col-xl-12">
                            <div className="row g-0 d-flex">
                                <div className="col-xl-6 col-lg-6 col-sm-12 order-lg-0 order-1 pb-lg-2 pb-3">
                                <h2 className="text-center mb-3 mt-3">Actualizar Perfil</h2>
                                    <img src={Image} className="bd-placeholder-img bd-placeholder-img-lg featurette-image img-fluid mx-auto p-lg-5 p-2" alt="Perfil de usario" width={500} />
                                </div>
                                <div className="col-lg-6 order-lg-0 order-">
                                    <Card className="rounded-start">
                                        <Card.Body className="py-4 px-5 rounded-start">
                                            {error && <Alert variant="danger">{error}</Alert>}
                                            <Form onSubmit={handleSubmit}>
                                            <p className="mb-0"><strong>Email actual:</strong> {currentUser.email}</p>
                                                <Form.Group id="email">
                                                    <Form.Label>Email</Form.Label>
                                                    <Form.Control type="email" ref={emailRef} required defaultValue={currentUser.emailRef} placeholder="Ingresa tu nuevo email" />
                                                </Form.Group>
                                                <Form.Group id="password">
                                                    <Form.Label>Contraseña</Form.Label>
                                                    <Form.Control type="password" ref={passwordRef} required placeholder="Ingresa tu nueva contraseña" />
                                                </Form.Group>
                                                <Form.Group id="password-confirm">
                                                    <Form.Label>Repetir Contraseña</Form.Label>
                                                    <Form.Control type="password" ref={passwordConfirmRef} required placeholder="Confirma tu nueva contraseña" />
                                                </Form.Group>
                                                <button disable={ setLoading.toString(loading) } className="w-100 mt-3 nav__btn btn-block fa-lg mb-3" type="submit">Actualizar</button>
                                                <div className="w-100 text-center mt-2">
                                                    <Link to="/" style={{color: '#ffa900'}}>Cancelar</Link>
                                                </div>
                                            </Form>
                                        </Card.Body>
                                    </Card>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Container>
            <Footer/>
        </div>
    </>
    )
}
